import { Link, useLocation } from 'react-router-dom';

export default function PageLayout({ children }) {
  const { pathname } = useLocation();

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0e1a', color: '#e2e8f0',
      display: 'flex', flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      {/* Nav */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '1.25rem 2rem', maxWidth: '1100px', margin: '0 auto', width: '100%',
        position: 'relative', zIndex: 10,
      }}>
        <Link to="/" style={{
          textDecoration: 'none', color: '#e2e8f0', fontWeight: 700,
          fontSize: '1.125rem', letterSpacing: '-0.02em',
          display: 'flex', alignItems: 'center', gap: '0.5rem',
        }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="1" y="10" width="4" height="8" rx="1" fill="#3b82f6" opacity="0.6" />
            <rect x="6" y="6" width="4" height="12" rx="1" fill="#3b82f6" opacity="0.8" />
            <rect x="11" y="2" width="4" height="16" rx="1" fill="#3b82f6" />
            <rect x="16" y="8" width="3" height="10" rx="1" fill="#3b82f6" opacity="0.5" />
          </svg>
          XposureFlow
        </Link>
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
          <NavLink to="/docs" active={pathname.startsWith('/docs')}>Docs</NavLink>
          <Link to="/chart" style={{
            color: '#3b82f6', fontWeight: 600, fontSize: '0.875rem',
            border: '1px solid rgba(59,130,246,0.4)', borderRadius: '6px',
            padding: '0.4rem 1.25rem', textDecoration: 'none',
            background: 'rgba(59,130,246,0.08)',
            transition: 'all 0.2s',
          }}>
            Login
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main style={{ flex: 1 }}>
        {children}
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #1e293b', padding: '2.5rem 2rem',
        textAlign: 'center', marginTop: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
          <FooterLink to="/terms">Terms of Use</FooterLink>
          <FooterLink to="/privacy">Privacy Policy</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
          <FooterLink to="/docs">Documentation</FooterLink>
        </div>
        <p style={{ color: '#334155', fontSize: '0.75rem', margin: 0 }}>
          &copy; {new Date().getFullYear()} XposureFlow. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

function NavLink({ to, active, children }) {
  return (
    <Link to={to} style={{
      color: active ? '#e2e8f0' : '#64748b', textDecoration: 'none',
      fontSize: '0.875rem', fontWeight: 500,
      borderBottom: active ? '1px solid #3b82f6' : '1px solid transparent',
      paddingBottom: '2px', transition: 'all 0.2s',
    }}>
      {children}
    </Link>
  );
}

function FooterLink({ to, children }) {
  return (
    <Link to={to} style={{
      color: '#475569', textDecoration: 'none', fontSize: '0.8rem',
      transition: 'color 0.15s',
    }}>
      {children}
    </Link>
  );
}
